import { accountsPageActionTypes } from "../actions/actiontypes";
import { DataActionTypes } from "../actions/actiontypes";

export const setAccountsData=(value)=>{
    return {
        type:DataActionTypes.set_AccountsData,
        payload:value
    }
}


export const setAccount=(value)=>{
    return {
        type:accountsPageActionTypes.set_account_on_select,
        payload:value
    }
}

export const setProfilePicture=(value)=>{
    return {
        type:accountsPageActionTypes.set_Profile_Picture,
        payload:value,
    }
}



export const setSelectedAccount=(value)=>{
    return{
        type:accountsPageActionTypes.set_selected_account,
        payload:value
    }
}